import { createContext, useContext } from 'react';
import { Config } from '../types';

export const ConfigContext = createContext<Config>(undefined!);

export function useConfigContext() {
  return useContext(ConfigContext);
}
